import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'IconSorting',
  props: {
    className: {},
    classStroke: {},
    size: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: _normalizeClass(_ctx.className),
    width: "19.414",
    height: "14",
    viewBox: "0 0 19.414 14"
  }, [
    _createElementVNode("line", {
      id: "Line_551",
      class: _normalizeClass(`${_ctx.classStroke} svg-stroke`),
      "data-name": "Line 551",
      x2: "9",
      transform: "translate(1 1)",
      fill: "none",
      stroke: "#888f94",
      "stroke-linecap": "square",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }, null, 2),
    _createElementVNode("line", {
      id: "Line_552",
      class: _normalizeClass(`${_ctx.classStroke} svg-stroke`),
      "data-name": "Line 552",
      x2: "7",
      transform: "translate(1 7)",
      fill: "none",
      stroke: "#888f94",
      "stroke-linecap": "square",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }, null, 2),
    _createElementVNode("line", {
      id: "Line_553",
      class: _normalizeClass(`${_ctx.classStroke} svg-stroke`),
      "data-name": "Line 553",
      x2: "7",
      transform: "translate(1 13)",
      fill: "none",
      stroke: "#888f94",
      "stroke-linecap": "square",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }, null, 2),
    _createElementVNode("path", {
      id: "Path_7715",
      class: _normalizeClass(`${_ctx.classStroke} svg-stroke`),
      "data-name": "Path 7715",
      d: "M15,15l3,3,3-3",
      transform: "translate(-3 -5)",
      fill: "none",
      stroke: "#888f94",
      "stroke-linecap": "square",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }, null, 2),
    _createElementVNode("line", {
      id: "Line_554",
      class: _normalizeClass(`${_ctx.classStroke} svg-stroke`),
      "data-name": "Line 554",
      y2: "13",
      transform: "translate(15)",
      fill: "none",
      stroke: "#888f94",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }, null, 2)
  ], 2))
}
}

})